import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const RadioCircleUnselect = ({
  size = 16,
  title = 'Unselect',
  fill = colors.silverSandAlt,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 30 29.993">
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M445.689,383.149a15,15,0,1,0-10.613,25.6h.008a14.994,14.994,0,0,0,
10.605-25.6Zm2.121,10.607a12.717,12.717,0,0,1-12.726,12.721h0a12.722,12.722,0,1,1,12.728-12.721Z
`}
        transform="translate(-420.083 -378.755)"
        fill={fill}
      />
    </svg>
  );
};
